<template>
  <div style="text-align: center;display: flex;align-items: center;height: 100%;justify-content: space-around">
    <div>
      <h1>请点击下方按钮，开始采集学信网信息采集</h1>
      <a-button @click="addInformationAcquisition" style="margin-top: 20px;background: #2caf7a;color: #fff;border: 1px solid #2caf7a">开始采集</a-button>
    </div>
    <a-modal title="信息采集" v-model="visibleImg">
      <div style="text-align: center">
        <img :src="'data:image/gif;base64,'+src" alt="" v-if="src!=''">
        <p style="color: red;text-align: left;margin-left: 33px">操作方法：</p>
        <p style="color: red">方法一：先用手机微信扫描上面图片，然后进入照片采集小程序；</p>
        <p style="color: red">方法二:在联大微信公众号-我的信息-开始采集，然后进入小程序；</p>

        <br><br>
        <a :href="openlink" v-if="openlink!=''">微信链接入口</a><br>
        <p>(PS:点击进入学信网照片采集小程序端)</p>
<!--        <img :src="'data:image/gif;base64,'+srcobj.src" alt=""><br>-->
<!--        <a :href="openlink" style="padding-top: 20px" >微信链接</a>-->

      </div>
      <template slot="footer">
        <p style="display: none"></p>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "InformationAcquisition",
  data(){
    return {
      src:'',
      openlink:'',
      visibleImg:false,
    }
  },
  methods:{
    addInformationAcquisition(){
      this.axios.post(`/photoCollect/handleInfo/push`).then((res)=>{
        if(res.code === 200){
          this.$message.success(res.message)
          this.visibleImg = true
          this.src = res.result.QRCode
          this.openlink = res.result.openlink
        }
      })
      // window.open()
    }
  }
}
</script>

<style scoped>
  img{
    width: 200px;
    height: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/InformationAcquisition.vue